 <div id="siteTable" #tableWrapper>
    <app-table
      [TableHeader]="header"
      [addApplication]="add_Edit"
      [buttonTitle]="header"
      [totalDisplay]="false"
      [modalId]="'add'+header"
  ></app-table>
  </div>

  <!-- Modal -->

<app-form-modal [Singlefields]="true" [modalId]="'add'+header" Modaltitle="Application" [header]="'Add New '+header" leftButtonTitle="Cancel" rightButtonTitle="Add" (value)="Additem($event)" ></app-form-modal>

<app-form-modal [Singlefields]="true" [inputValue]="selectedItem" [modalId]="'edit'+header" Modaltitle="Edit" [header]="'Edit '+header" leftButtonTitle="Cancel" rightButtonTitle="Edit" (value)="editItem($event)" ></app-form-modal>
